import { IMyLinkTalentInfo, PreferencesProps } from 'pages/MyLinks/types';
import { useCallback, useEffect, useState } from 'react';
import { useAppSelector } from 'shared/redux/store';

export const useMyLinks = () => {
  const { user: userState } = useAppSelector((state) => state);
  const [agencyActivated, setAgencyActivated] = useState<boolean>(false);
  const [preferences, setPreferences] = useState<PreferencesProps | undefined>(undefined);
  const [talentInfo, setTalentInfo] = useState<IMyLinkTalentInfo>({
    talent_slug: '',
    talent_country_code: '',
    talent_picture: '',
    talent_stage_name: '',
    talent_public_active_link: false,
  });

  useEffect(() => {
    setPreferences(userState?.user?.attributes?.preferences);
  }, [userState]);

  const changeSlug = useCallback((newSlug: string) => {
    setTalentInfo((prev) => {
      return { ...prev, talent_slug: newSlug };
    });
  }, []);

  const changeActiveLink = useCallback(() => {
    setTalentInfo((prev) => {
      return { ...prev, talent_public_active_link: !prev.talent_public_active_link };
    });
  }, []);

  const handleAgencyActivated = (value: boolean) => {
    setAgencyActivated(value);
  };

  useEffect(() => {
    if (userState) {
      const talent_country_code =
        userState?.user?.attributes?.other_phone_numbers.find((phone) => phone?.type === 'primary')?.country_code || '';
      const talent_slug = userState?.user?.attributes?.slug;
      const talent_picture = userState?.user?.attributes?.picture;
      const talent_stage_name = userState?.user?.attributes?.stage_name;
      const talent_public_active_link = userState?.user?.attributes?.preferences?.public_link_active || false;
      setTalentInfo({
        talent_slug,
        talent_country_code,
        talent_picture,
        talent_stage_name,
        talent_public_active_link,
      });
    }
  }, [userState]);

  return {
    talentInfo,
    changeSlug,
    changeActiveLink,
    meLoading: false,
    preferences,
    agencyActivated,
    handleAgencyActivated,
  };
};
